angular.module('pl-shared')
  .filter('numberToDayOfMonth', function(moment) {
    return function(input) {
      if (!input) return
      return moment(input, 'Do').format('Do')
    }
  })
